import React from "react";
import { Button, ArrowRightIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const DefaultButtonWithEndIcon = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Contained button with end icon"}
        value={"<Button endIcon={<ArrowRightIcon />}>Next</Button>"}
      >
        <Button endIcon={<ArrowRightIcon />}>Next</Button>
      </PreviewAndEditor>
    </>
  );
};

export default DefaultButtonWithEndIcon;
